// helper functions to toggle a class name on an element
function removeClass(el, classname) {
    if (typeof el === 'undefined') return;
    el.className = el.className.replace(" " + classname, "");
}

function addClass(el, classname) {
    el.className += " " + classname;
}

function hasClass(el, classname) {
    return ((" " + el.className + " ").replace(/[\t\r\n]/g, " ").indexOf(" " + classname + " ") >= 0);
}

// glider script
function glider_script() {
    var slider = document.querySelector('.new-carousel');
    var controller = document.querySelector('.carousel-controller');
    if (slider) {
        // current slide
        var curSlide = 0;
        // the slides
        var allSlides = document.querySelectorAll('.new-carousel .slide');
        var totalSlides = allSlides.length;
        // controls
        var cButtons = document.querySelectorAll('.carousel-controller button');
        // glider object
        var glider = new Glider(slider, {
            slidesToShow: 1,
            slidesToScroll: totalSlides,
            arrows: {
                prev: '.prev',
                next: '.next'
            },
            rewind: true,
            duration: 0
        }); 
        // click behavior
        // controller.addEventListener('click', function (e) {
        //     // if a button was clicked, move slide to index
        //     if (e.target.nodeName == 'BUTTON') {
        //         var index = e.target.getAttribute('data-index');
        //         // if (sliderTimer) {
        //         //     clearInterval(sliderTimer);
        //         // }
        //         curSlide = +index;
        //         glider.scrollItem(+index);
        //         console.log(e.target);
        //     }
        // })
        // timer for changing the slides
        // var sliderTimer = setInterval(function () {
        //     removeClass(cButtons[curSlide], 'active');
        //     if (curSlide + 1 != totalSlides) {
        //         curSlide++;
        //     } else {
        //         curSlide = 0;
        //     }
        //     glider.scrollItem(curSlide);
        // }, 5000)
    }
}
window.addEventListener('DOMContentLoaded', function (e) {
    glider_script();
});